import { ICreateObraChecklistServicosUseCase } from "../../../presentation/useCases/create/create_checklist_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateChecklistServicosUseCase
 */

export class CreateObraChecklistServicosUseCase implements ICreateObraChecklistServicosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraChecklistServicos(
    idObra: number | undefined,
    idObraAreaChecklist: number | undefined,
    checklistServicos: number[],
  ): Promise<void> {
    if (idObra === undefined) throw new Error("Id de obra invalido!");
    if (idObraAreaChecklist === undefined) throw new Error("Id de area invalido!");

    await this.repository.createObraChecklistServicos(
      idObra, idObraAreaChecklist, checklistServicos);
  }
}
